<template>
    <div class="md-layout-item">
        <h4>Options</h4>
        <div v-bind:key="index" v-for="(option, index) in options_list" class="md-layout md-gutter">
            <div v-if="multiple" class="md-layout-item">
                <md-checkbox v-model="option.checked"></md-checkbox>
            </div>
            <div class="md-layout-item">
               <md-field>
                    <label>Label</label>
                    <md-input v-model="option.label"></md-input>
                </md-field>
            </div>
            <div class="md-layout-item">
                <md-field>
                    <label>Value</label>
                    <md-input v-model="option.value"></md-input>
                </md-field>
            </div>
            <div class="md-layout-item">
                <md-button @click="removeOption(index)">Remove</md-button>
            </div>
        </div>
        <md-button class="md-raised md-primary" @click="addOption">Add Option</md-button>
    </div>
</template>

<script>
export default {
  name: "FbSelectOption",
  props: ["select", "multiple"],
  data() {
    return {
      options_list: this.select,
    };
  },
  methods: {
    addOption() {
      this.options_list.push({
        checked: false,
        label: "",
        value: "",
      });
    },
    removeOption(index) {
      this.options_list.splice(index, 1);
    },
  },
};
</script>